export default __webpack_public_path__ + "static/media/dashboard.4593822c.svg";